<template>
    <div class="px-4 pt-4 sm:px-6">
        <h3 class="col-span-2 text-base font-semibold">
            {{ $t('country_tax_residencies.tax_residency') }}
        </h3>
        <div class="divide-y divide-gray-300">
            <div v-for="(tin, index) in account.tax_residencies" :key="index">
                <TaxResidencyRow
                    v-model:country="tin.country"
                    v-model:no_tin_reason="tin.no_tin_reason"
                    v-model:tin="tin.tin"
                    :disabled="isNaturalTaxResidenciesEditDisabled()"
                    :index="index"
                    @remove="removeRow(index)" />
            </div>
        </div>
    </div>
    <div class="px-4 sm:px-6">
        <BaseButtonPrimary :disabled="reachedTinLimit || isNaturalTaxResidenciesEditDisabled()" @click="addRow()">
            <PlusIcon class="mr-2 w-6"></PlusIcon>
            {{ $t('country_tax_residencies.add_another_tax_residence') }}
        </BaseButtonPrimary>
    </div>
</template>

<script setup lang="ts">
import {
    isNaturalTaxResidenciesEditDisabled,
    TaxResidency,
    usePersonalAccountDataState,
} from '../../../../../utilities/account/useAccountDataPersonal'
import { computed, onMounted, onUnmounted } from 'vue'
import BaseButtonPrimary from '../../../../base/BaseButtonPrimary.vue'
import TaxResidencyRow from '../TaxResidencyRow.vue'
import { PlusIcon } from '@heroicons/vue/outline'
import { clearIncompleteTaxResidencies } from '../../../../../validation'

const { naturalProfile: account } = usePersonalAccountDataState()

const reachedTinLimit = computed(() => {
    return account.tax_residencies.length >= 5
})

function removeRow(index) {
    account.tax_residencies.splice(index, 1)
}

function addRow() {
    account.tax_residencies.push(new TaxResidency())
}

onMounted(() => {
    if (account.tax_residencies.length === 0) {
        addRow()
    }
})

onUnmounted(() => {
    account.tax_residencies = clearIncompleteTaxResidencies(account.tax_residencies)
})
</script>
